import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import DropDown from "../../../../DropDown/DropDown";
import './CreateProject.css';
import ProjectAPIs from "../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useToast } from "../../../../../Contexts/ToastContext";
import ProjectsMap from "../../ProjectsMap/ProjectsMap";
import ApiResponseHandler from "../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import LookupAPIs from "../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import { useEffect } from "react";

export default function CreateProject(){


    const {addToast} = useToast();
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);
    const [name, setName] = useState('');
    const [cisID, setCisID] = useState('');
    const [counties, setCounties] = useState([])
    const [countries, setCountries] = useState([])
    // const [completed, setCompletedID] = useState(false);
    
    const [line1, setLine1] = useState('');
    const [line2, setLine2] = useState('');
    const [city, setCity] = useState('');
    const [countyID, setCountyID] = useState(0);
    const [countryID, setCountryID] = useState(0);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);

    const [applicant, setApplicant] = useState('');
    const [architectCompID, setArchitectCompId] = useState('');
    const [architectID, setArchitectID] = useState('');
    const [engineerCompID, setEngineerCompID] = useState('');
    const [engineerID, setEngineerID] = useState('');
    // const [contactedEng, setContactedEngID] = useState(false);
    const [categoryID, setCategoryID] = useState('');
    const [sectorID, setSectorID] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [inductionReq, setInductReq] = useState(true);
    const [inductionProvided, setInductProv] = useState('');
    const [buildDesc, setBuildDesc] = useState('');
    const [footprint, setFootprint] = useState('');
    const [frameMatID, setFrameMatID] = useState('');
    const [floorMatID, setFloorMatID] = useState('');
    const [envelopeMatID, setEnvelopeMatID] = useState('');
    const [roofMatID, setRoofMatID] = useState('');
    const [partitioningMatID, setPartitioningMatID] = useState('');
    const [mainContractorID, setMainContractorID] = useState('');
    const [accountContactID, setAccountContactID] = useState('');
    const [foremanID, setForemanID] = useState('');
    const [safetyOffID, setSafeOffID] = useState('');
    const [storemanID, setStoremanID] = useState('');

    // console.log(endDate);
    const [pageIndex, setPageIndex] = useState(0);

    const getCounties = async () => {
        try{
            const response = await LookupAPIs.GetCounties();
            setCounties(response.data)
        }
        catch(err){
            ApiResponseHandler(err.response, navigate);
        }
    }

    const getCountries = async () => {
        try{
            const response = await LookupAPIs.GetCountries();
            setCountries(response.data)
        }
        catch(err){
            ApiResponseHandler(err.response, navigate);
        }
    }

    const normalize = (str) =>
  str?.toLowerCase().replace("county ", "").trim();

    const handleReverseGeocode = (formattedData) => {
        console.log(formattedData);
        setLat(formattedData.latitude)
        setLng(formattedData.longitude)
        if(formattedData.line1 !== ""){
            setLine1(formattedData.line1)
            setLine2('')
        }
        
        if(formattedData.city !== ""){ 
            setCity(formattedData.city)
        };

        if(formattedData.county !== ""){
            const countyName = normalize(formattedData.county);
            const matchedCounty = counties.find(
                (c) => normalize(c.county) === countyName
            );
            setCountyID(matchedCounty?.id ?? '');
            console.log('matchedCounty');
            console.log(matchedCounty);
        }
        if(formattedData.country !== ""){
            const countryName = normalize(formattedData.country);
            const matchedCountry = countries.find(
                (c) => normalize(c.country) === countryName
            );
            setCountryID(matchedCountry?.id ?? '');
            console.log('matchedCountry');
            console.log(matchedCountry);
        }
        
    }

    const handleNextPage = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(pageIndex < 5){
            setPageIndex(pageIndex+1);
        }
    }

    const handleSubmit = (e) => {

        e.preventDefault();
        e.stopPropagation();

        setSending(true);

        const addressJSON = {
            line1: line1,
            line2: line2 === '' ? null : line2,
            city: city === '' ? null : city,
            county_id: countyID,
            country_id: countryID,
            longitude: lng === '' ? null : lng,
            latitude: lat === '' ? null : lat
        }

        const PostJSON = {
            name: name,
            cis_id: cisID === '' ? null : cisID,
            completed: false,
            address: addressJSON,
            applicant: applicant,
            architect_company_id: architectCompID === '' ? null : architectCompID,
            architect_id: architectID === '' ? null : architectID,
            engineering_company_id: engineerCompID === '' ? null : engineerCompID,
            engineer_id: engineerID === '' ? null : engineerID,
            contacted_engineer: false,
            category_id: categoryID,
            sector_id: sectorID,
            start_date: startDate === '' ? null : startDate,
            end_date: endDate === '' ? null : endDate,
            induction_required: inductionReq,
            induction_provided: inductionProvided === '' ? null : inductionProvided,
            building_description: buildDesc,
            footprint: footprint === '' ? null : footprint,
            frame_material_id: frameMatID === '' ? null : frameMatID,
            floor_material_id: floorMatID === '' ? null : floorMatID,
            envelope_material_id: envelopeMatID === '' ? null : envelopeMatID,
            roof_material_id: roofMatID === '' ? null : roofMatID,
            partitioning_material_id: partitioningMatID === '' ? null : partitioningMatID,
            main_contractor_id: mainContractorID === '' ? null : mainContractorID,
            account_contact_id: accountContactID === '' ? null : accountContactID,
            foreman_id: foremanID === '' ? null : foremanID,
            safety_officer_id: safetyOffID === '' ? null : safetyOffID,
            storeman_id: storemanID === '' ? null : storemanID

        }

        
        ProjectAPIs.PostProject(PostJSON)
        .then((newProject) => {
            if(newProject.status === 200){
            navigate('/project/' + newProject.data.id)
            setSending(false);
            addToast({ message: "Project added successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                    setSending(false);
                }
            }
        })
    }


    useEffect(() => {
        getCounties();
        getCountries();
    }, []);


    return(
        // <div className="create-project">

        //     <div>
        //         <Button onClick={() => navigate('/project')}>Back to Projects</Button>
        //     </div>
        //     <div align='center'>
        //         <span>{pageIndex + 1} / 6</span>
        //     </div>
            

        //         {pageIndex === 0 &&
                
        //         <Card>
        //             <Card.Header>
        //             Basic Information
        //             </Card.Header>
        //             <Form onSubmit={handleNextPage}>
        //             <Card.Body>
        //                 <Row>
        //                     <Col sm={8}>
        //                         <strong>Title</strong>
        //                         <Form.Control size='sm' required value={name} onChange={(e) => setName(e.target.value)} />
        //                     </Col>
        //                     <Col>
        //                         <strong>CIS ID</strong>
        //                         <Form.Control size='sm' value={cisID} onChange={(e) => setCisID(e.target.value)} />
        //                     </Col>
        //                 </Row>
                        
        //                 <strong>Building Description:</strong>
        //                 <Form.Control size='sm' as="textarea" rows={2}  value={buildDesc} onChange={(e) => setBuildDesc(e.target.value)}/>

        //                 <Row>
        //                     <Col>
        //                         <strong>Promoter</strong>
        //                         <Form.Control size='sm' required value={applicant} onChange={(e) => setApplicant(e.target.value)} />
        //                     </Col>
        //                     <Col>
        //                         <strong>Footprint {'('}m<sup>2</sup>{')'}</strong>
        //                         <Form.Control size='sm' type="number" value={footprint} onChange={(e) => setFootprint(e.target.value)} />
        //                     </Col>
        //                 </Row>
        //                 <Row>
        //                     <Col>
        //                     <strong>Category</strong>
        //                         <DropDown.Category size='sm' required value={categoryID} onChange={(e) => {
        //                                 setCategoryID(e.target.value);
        //                                 setSectorID('');
        //                             }} />
        //                     </Col>
        //                     <Col>
        //                         <strong>Sector</strong>
        //                         <DropDown.CategorySectors 
        //                             size='sm'
        //                             required 
        //                             categoryID={categoryID} 
        //                             disabled={categoryID === ''} 
        //                             value={sectorID} 
        //                             onChange={(e) => setSectorID(e.target.value)} 
        //                         />
        //                     </Col>
        //                 </Row>
        //                 <Row>
        //                     <Col>
        //                         <strong>Start Date</strong>
        //                         <Form.Control size='sm' type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        //                     </Col>
        //                     <Col>
        //                         <strong>End Date</strong>
        //                         <Form.Control size='sm' type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        //                     </Col>
        //                 </Row>
        //                 <Row>
        //                     <Col><button disabled>Back</button></Col>
        //                     <Col align='end'><button type='submit'>Next</button></Col>
        //                 </Row>
        //             </Card.Body>
        //             </Form>

        //         </Card>
        //         }
                
        //         {pageIndex === 1 &&
        //         <Card>
        //             <Card.Header>Address</Card.Header>
        //             <Form onSubmit={handleNextPage}>
                    
        //             <Card.Body>
        //             <strong>Line 1</strong>
        //             <Form.Control size='sm' required value={line1} onChange={(e) => setLine1(e.target.value)} />

        //             <strong>Line 2</strong>
        //             <Form.Control size='sm' value={line2} onChange={(e) => setLine2(e.target.value)} />

        //             <strong>City</strong>
        //             <Form.Control size='sm' value={city} onChange={(e) => setCity(e.target.value)} />

        //             <strong>County</strong>
        //             <DropDown.County size='sm' required value={countyID} onChange={(e) => setCountyID(e.target.value)} />

        //             <strong>Country</strong>
        //             <DropDown.Country size='sm' required value={countryID} onChange={(e) => setCountryID(e.target.value)} />

                  
        //             <Row>
        //                 <Col>
        //                     <button type='button' onClick={() => setPageIndex(pageIndex-1)}>Back</button>
        //                 </Col>
        //                 <Col align='end'>
        //                     <button type='submit'>Next</button>
        //                 </Col>
        //             </Row>
                        
                        
        //             </Card.Body>
        //             </Form>
        //         </Card>
        //         }

        //         {pageIndex === 2 &&
        //         <Card>
                    
        //             <Card.Header>Materials</Card.Header>
        //             <Form onSubmit={handleNextPage}>
        //             <Card.Body>

                        
        //             <strong>Frame Material</strong>
        //             <DropDown.FrameMaterial size='sm' value={frameMatID} onChange={(e) => setFrameMatID(e.target.value)} />

        //             <strong>Floor Material</strong>
        //             <DropDown.FloorMaterial size='sm' value={floorMatID} onChange={(e) => setFloorMatID(e.target.value)} />

        //             <strong>Envelope Material</strong>
        //             <DropDown.EnvelopeMaterial size='sm' value={envelopeMatID} onChange={(e) => setEnvelopeMatID(e.target.value)} />

        //             <strong>Roof Material</strong>
        //             <DropDown.RoofMaterial size='sm' value={roofMatID} onChange={(e) => setRoofMatID(e.target.value)} />

        //             <strong>Partitioning Material</strong>
        //             <DropDown.PartitioningMaterial size='sm' value={partitioningMatID} onChange={(e) => setPartitioningMatID(e.target.value)} />
                    
                    
        //             <Row>
        //                 <Col>
        //                     <button type='button' onClick={() => setPageIndex(pageIndex-1)}>Back</button>
        //                 </Col>
        //                 <Col align='end'>
        //                     <button type='submit'>Next</button>
        //                 </Col>
        //             </Row>
                    
        //             </Card.Body>
        //             </Form>
        //         </Card>
        //         }   

                

                
        //         {pageIndex === 3 &&
        //         <Card>
        //             <Form onSubmit={handleNextPage}>
        //                 <Card.Header>Induction</Card.Header>
        //                 <Card.Body>
        //                     <strong>Required: <input type="checkbox" checked={inductionReq} onChange={(e) => setInductReq(!inductionReq)} /></strong>
        //                     <div>
        //                     <strong>Induction Provided on:</strong>
        //                     <Form.Control size='sm' as="textarea" rows={2}  value={inductionProvided} onChange={(e) => setInductProv(e.target.value)}/>
        //                     </div>
        //                     <Row>
        //                         <Col>
        //                             <button type='button' onClick={() => setPageIndex(pageIndex-1)}>Back</button>
        //                         </Col>
        //                         <Col align='end'>
        //                             <button type='submit'>Next</button>
        //                         </Col>
        //                     </Row>
        //                 </Card.Body>
        //             </Form>
        //         </Card>
        //         }
                
                
                
                

        //         { pageIndex === 4 &&
        //         <Card>
        //             <Card.Header>Main Contractor</Card.Header>
        //             <Form onSubmit={handleNextPage}>
        //                 <Card.Body>
        //                 <strong>Company</strong>
        //                 <DropDown.AllCompanies size='sm'  value={mainContractorID} onChange={(e) => setMainContractorID(e.target.value)} />

        //                 <strong>Account Contact</strong>
        //                 <DropDown.CompanyEmployees size='sm' companyID={mainContractorID} disabled={mainContractorID === ''} value={accountContactID} onChange={(e) => setAccountContactID(e.target.value)} />

        //                 <strong>Foreman</strong>
        //                 <DropDown.CompanyEmployees size='sm' companyID={mainContractorID} disabled={mainContractorID === ''} value={foremanID} onChange={(e) => setForemanID(e.target.value)} />

        //                 <strong>Safety Officer</strong>
        //                 <DropDown.CompanyEmployees size='sm' companyID={mainContractorID} disabled={mainContractorID === ''} value={safetyOffID} onChange={(e) => setSafeOffID(e.target.value)} />

        //                 <strong>Storeman</strong>
        //                 <DropDown.CompanyEmployees size='sm' companyID={mainContractorID} disabled={mainContractorID === ''} value={storemanID} onChange={(e) => setStoremanID(e.target.value)} />
                    
        //             <Row>
        //                 <Col>
        //                     <button type='button' onClick={() => setPageIndex(pageIndex-1)}>Back</button>
        //                 </Col>
        //                 <Col align='end'>
        //                     <button type='submit'>Next</button>
        //                 </Col>
        //             </Row>
                    
                    
        //                 </Card.Body>
        //             </Form>
        //         </Card>
        //         }

        //         {pageIndex === 5 &&
        //         <Card>
        //             <Card.Header>Contacts</Card.Header>
        //             <Form onSubmit={handleSubmit}>
        //                 <Card.Body>
        //                     <strong>Architect Company</strong>
        //                     <DropDown.AllCompanies size='sm'  value={architectCompID} onChange={(e) => setArchitectCompId(e.target.value)} />

        //                     <strong>Architect</strong>
        //                     <DropDown.CompanyEmployees size='sm' companyID={architectCompID} disabled={architectCompID === 0} value={architectID} onChange={(e) => setArchitectID(e.target.value)} />


        //                     <strong>Engineering Company</strong>
        //                     <DropDown.AllCompanies size='sm' value={engineerCompID} onChange={(e) => setEngineerCompID(e.target.value)} />

        //                     <strong>Engineer</strong>
        //                     <DropDown.CompanyEmployees size='sm' companyID={engineerCompID} disabled={engineerCompID === 0} value={engineerID} onChange={(e) => setEngineerID(e.target.value)} />
                            
        //                     <Row>
        //                         <Col>
        //                             <button type='button' onClick={() => setPageIndex(pageIndex-1)}>Back</button>
        //                         </Col>
        //                         <Col align='end'>
        //                         <button type='submit' disabled={sending}>{sending ? 'Creating...' : 'Finish'}</button>
        //                         </Col>
        //                     </Row>
                            

        //                 </Card.Body>
                    
        //             </Form>
        //             </Card>
        //         }

             
            

            
        // </div>

        <div className='tab-panel active'>
            <Form onSubmit={handleSubmit}>
        <div className="project-section">

            <div className="project-section-header">
                <h5 className="section-title">Create New Project</h5>
                <div className="project-header-actions">
                    <button disabled={sending} type ='button' onClick={() => navigate('/project')} className="cancel-btn">Back to Projects</button>
                    <button disabled={sending} type='submit' className="edit-btn">Save</button>
                </div>

            </div>

            <div className="m-2">

                <div className="project-section-body-item">
                    <span className="label">Title</span>
                </div>
                <div>
                    <Form.Control size='sm' disabled={sending} className='project-title-input editable-field' required value={name} onChange={(e) => setName(e.target.value)} />
                </div>

                <div className="project-section-body-item">
                <span className="label">Description</span>
                </div>
                <div className="project-section-body-item">
                    <Form.Control size='sm' as="textarea" rows={2} disabled={sending} className='editable-field' value={buildDesc} onChange={(e) => setBuildDesc(e.target.value)}/>
                </div>

                <div className="project-section-body mt-2 mb-2">

                <div className="project-section-body-item">
                    <span className="label">Promoter</span>
                    <Form.Control size='sm'  rows={2} disabled={sending} className='editable-field' value={applicant} onChange={(e) => setApplicant(e.target.value)}/>
                </div>


                <div className="project-section-body-item">
                    <span className="label">Category</span>
                    <DropDown.Category size='sm' required disabled={sending} className='editable-field' value={categoryID} onChange={(e) => {
                            setCategoryID(e.target.value);
                            setSectorID('');
                        }} />
                </div>

                <div className="project-section-body-item">
                    <span className="label">Sector</span>
                    <DropDown.CategorySectors 
                        size='sm'
                        required 
                        categoryID={categoryID} 
                        disabled={(categoryID === '') || sending} 
                        value={sectorID} 
                        className='editable-field'
                        onChange={(e) => setSectorID(e.target.value)} 
                    />
                </div>

                </div>


                <h5 className="section-title">Project Address</h5>

                <div className="project-section-body">

                

                <div className="project-section-body-item">
                    <span className="label">Line 1</span>
                    <Form.Control size='sm' disabled={sending} className="editable-field" required value={line1} onChange={(e) => setLine1(e.target.value)} />
                </div>

                <div className="project-section-body-item">
                    <span className="label">Line 2</span>
                    <Form.Control size='sm' disabled={sending} className="editable-field" value={line2} onChange={(e) => setLine2(e.target.value)} />
                </div>

                <div className="project-section-body-item">
                    <span className="label">City</span>
                    <Form.Control size='sm' disabled={sending} className="editable-field" value={city} onChange={(e) => setCity(e.target.value)} />
                </div>

                <div className="project-section-body-item">
                    <span className="label">County</span>
                    <DropDown.County size='sm' disabled={sending} className="editable-field" required value={countyID} onChange={(e) => setCountyID(e.target.value)} />
                </div>

                <div className="project-section-body-item">
                    <span className="label">Country</span>
                    <DropDown.Country size='sm' required value={countryID} onChange={(e) => setCountryID(e.target.value)} />
                </div>
                </div>
            </div>

            
            </div>

            </Form>

            <div className="map-container">
                <ProjectsMap mode={'create'}  handleReverseGeocode={handleReverseGeocode} />
            </div>
            
        
        </div>
    )

}